import React from "react";
import PropTypes from "prop-types";
import { cn } from "../../lib/utils";

const Switch = React.forwardRef(({
  className,
  checked = false,
  onCheckedChange,
  onClick,
  disabled,
  ...props
}, ref) => {
  const handleClick = (event) => {
    onClick?.(event);

    if (!event.defaultPrevented) {
      onCheckedChange?.(!checked);
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      data-state={checked ? "checked" : "unchecked"}
      className={cn("ui-switch", className)}
      disabled={disabled}
      onClick={handleClick}
      ref={ref}
      {...props}
    >
      <span className="ui-switch__thumb" aria-hidden="true" />
    </button>
  );
});

Switch.displayName = "Switch";

Switch.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool,
  onCheckedChange: PropTypes.func,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export { Switch };
